export default "__VITE_ASSET__Cvf3_Hfp__"